// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import TreeView from "@material-ui/lab/TreeView";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import ChevronRightIcon from "@material-ui/icons/ChevronRight";
// import TreeItem from "@material-ui/lab/TreeItem";

// const data = {
//   id: "root",
//   name: "Parent",
//   children: [
//     {
//       id: "1",
//       name: "Child - 1",
//     },
//     {
//       id: "3",
//       name: "Child - 3",
//       children: [
//         {
//           id: "4",
//           name: "Child - 4",
//         },
//       ],
//     },
//   ],
// };

// const useStyles = makeStyles({
//   root: {
//     height: 110,
//     flexGrow: 1,
//     maxWidth: 400,
//   },
// });

// const TreeViewStyle = () => {
//   const classes = useStyles();

//   const renderTree = (nodes) => (
//     <TreeItem key={nodes.id} nodeId={nodes.id} label={nodes.name}>
//       {Array.isArray(nodes.children)
//         ? nodes.children.map((node) => renderTree(node))
//         : null}
//     </TreeItem>
//   );
//   return (
//     <TreeView
//       className={classes.root}
//       defaultCollapseIcon={<ExpandMoreIcon />}
//       defaultExpanded={["root"]}
//       defaultExpandIcon={<ChevronRightIcon />}
//     >
//       {renderTree(data)}
//     </TreeView>
//   );
// };

// export default TreeViewStyle;

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Favorite from "@material-ui/icons/Favorite";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import InfoIcon from "@material-ui/icons/Info";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import FiberManualRecordOutlinedIcon from "@material-ui/icons/FiberManualRecordOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import grey from "@material-ui/core/colors/grey";
import ItemCustom from "./ItemCustom";
import { red } from "@material-ui/core/colors";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleRight, faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import RedCross from "../../../Icons/RedCross";
import {useDispatch,addContexts,useSelector} from "../../../Redux";
import { useTranslation } from "react-i18next";
import { GetStateFromData } from "../../../components/CustomHooks/CustomHooks";

const l_grey = grey[300];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    // padding: `0px ${theme.spacing(3)}px`,
    padding: 0,
  },
  listItem: {
    textAlign:window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"?"right":null,
    padding: 0,
  },
  listItemText: {
    flex: "0 1 auto",
    marginRight: "7px",
  },
  body1: {
    fontWeight: "bold",
  },
  listIcon: {
    minWidth: "unset",
    color: "black",
  },
  // arrow: {
  //   color: theme.palette.common.white,
  // },
  // tooltip: {
  //   backgroundColor: theme.palette.common.white,
  // },
  customWidth: {
    color: theme.palette.common.black,
    backgroundColor: theme.palette.common.white,
    boxShadow: "0px 1px 10px black",
    // border: "0.1px solid black",
    maxWidth: 160,
    fontSize: 12,

    // border: "0.5px solid black",
    // color: "black",
  },
  // bulletIcon: {
  //   fontSize: "10px",
  //   marginRight: "5px",
  // },
}));

// function BootstrapTooltip(props) {
//   const classes = useStyles();

//   return <Tooltip arrow classes={classes} {...props} />;
// }

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

// const ShowBrackets = ({ data, length }) => {
//   const text = length > 1 ? "items" : "item";
//   const brackets = Array.isArray(data) ? " [...]" : " {...}";
//   return (
//     <Typography component="span" variant="body2" color="textSecondary">
//       {`${brackets} // ${length} ${text}`}
//     </Typography>
//   );
// };

export default function TreeCustom({
  data,
  length,
  parentName,
  isfirst,
  filter,
  totalparent,
  entry,
  samplejson,
  ischeckbox,
  increasenumber,
  decreasenumber,
  handleArr,
  arr,
  stateForCustomServiceJson,
  setStateForCustomServiceJson,
  saveInJson,
  searching,
  searchWord,
  parentMapping,
  childMapping,
  setparentMapping,
  setchildMapping,
  setSelectedMappedValue,
  selectedMappedValue,
  parentChildCustom,
  setParentChildCustom,
  showMapButtonState,
  setShowMapButtonState,
  customServiceIds,
  setcustomServiceIds
}) {
  const {t}=useTranslation();
  const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";    
  const classes = useStyles();
  const [boxes, setBoxes] = React.useState(0);
  const [open, setOpen] = React.useState(true);
  const [map, setMap] = React.useState(false);
  const [hiding, setHiding] = React.useState(false);
  // const [filter, setFilter] = React.useState("");
  // const [first, setFirst] = React.useState(isfirst);
  const [showBackgroundColor, setShowBackgroundColor] = React.useState(false);


  const contexts = GetStateFromData();

const {MapId, 
  // parentChildCustom, 
  setMapId }=contexts.contexts;

  let isone = true;
  const handleClick = () => {
    setOpen(!open);
  };

  const func = () => {
    setHiding(!hiding);
  };
  const func2 = () => {
    setMap(!map);
  };

  function clickOnParent(data, event){
    
    if(parentChildCustom === "parent")
    {
      if(!childMapping){
      setShowBackgroundColor(!showBackgroundColor);
      
       if(showMapButtonState==="")
       {
       setShowMapButtonState(parentName)
       }else{
        setShowMapButtonState("")
       }

      event.stopPropagation();
      }
    }

  }

  var inputStyle={
    backgroundColor:"#FFFFFF"
  };

  var inputStyleAfterClick={
    backgroundColor:"#0072C619"
  }

  function JsonMapButton(parentName, event){
      //  console.log("parentName ", parentName)
      var mappedinput={
        mappedinput:stateForCustomServiceJson
      }

    

      //  data["mappedinput"]=stateForCustomServiceJson;

      //  data["mappedinput"]=MapId;
      //  setMapId("");

       data["mappedinput"] = selectedMappedValue;
       customServiceIds.add(selectedMappedValue);
       setSelectedMappedValue("");
       setShowMapButtonState("");
       
       setShowBackgroundColor(!showBackgroundColor);


      // setStateForCustomServiceJson();
      //  console.log("parentName ", stateForCustomServiceJson);
      //  console.log("parentName ", data);
      event.stopPropagation();
      // setStateForCustomServiceJson();
  }

  function JsonUnMapButton(event){

      var unmappedSet = new Set();

      customServiceIds.forEach(function(value){
        unmappedSet.add(value);
      })

      unmappedSet.delete(data["mappedinput"]);

      setcustomServiceIds(unmappedSet);

   //  customServiceIds.delete(data["mappedinput"]);

      data["mappedinput"]="";
      delete data["mappedinput"];
      setShowBackgroundColor(!showBackgroundColor);
      setShowMapButtonState("");
      event.stopPropagation();
  }



  return (
    <div  style={{maxHeight:"450px", overflowY:"auto"}}>
      {data && !isfirst
        ? Object.keys(data).map((v, i) => {
            return data[v] != null
          //  && typeof data[v] === "object" 
             ? (
              v.toLowerCase().indexOf(filter.toLowerCase()) > -1 ? (
                isone ? (
                  <>
                    {(isone = false)}
                    <ListItem
                      key={Math.random() * 10}
                      button
                      onClick={handleClick}
                      classes={{ root: classes.listItem }}
                      // style={showBackgroundColor ? inputStyleAfterClick : inputStyle}

                      style={(showMapButtonState===parentName) ? inputStyleAfterClick : inputStyle}
                    >
                      <ListItemIcon
                        key={Math.random() * 10}
                        classes={{ root: classes.listIcon }}
                      >
                        {open ? <ExpandMore /> : translationStyles1? <ChevronLeft/>: <ChevronRight />}
                      </ListItemIcon>
              
                      <ListItemText key={Math.random() * 10}>
                        {parentName
                         ? (
                          <>
                          <span
                            style={{
                              font: "normal normal 600 12px/17px Open Sans",
                            }}
                            onClick={(event)=>clickOnParent(data[v], event)}
                          >
                            {parentName}
                          </span>
                              {data && data["mappedinput"] ?
                                <>
                                &nbsp;
                              <FontAwesomeIcon key={'faChevronCircle'} icon={translationStyles1?faChevronCircleLeft : faChevronCircleRight} /> &nbsp;
                              <span
                               style={{
                                font: "normal normal 600 12px/17px Open Sans",
                                color: "#005EA3"
                              }}
                              >
                              {data["mappedinput"]}
                              </span>
                              </> : null}

                              {data && data["mappedinput"]   ?
                                <>
                                    <span style={{marginLeft:"auto",  color:"red",  fontSize:"10px", marginRight:"14px"
                                  }}
                                    onClick={(event)=>JsonUnMapButton(event)}
                                  > {t("UnMap")} &nbsp; <RedCross/> </span>
                                  </>
                                : "" }

                              </>

                        ) : (
                          ""
                        )}
                      </ListItemText>


                      {/* {showBackgroundColor ? */}
                      {(showMapButtonState===parentName) ?
                       <button style={{margin:"0px 5px 0px 5px !important", backgroundColor:"#0072c6", color:"#ffffff", border:"none",
                        borderRadius:"2px", height:"22px !important", fontSize:"10px" , marginRight:"5px"
                          }}
                  //     key={props.dt["value"]} 
                        onClick={(event)=>JsonMapButton(parentName, event)} 
                        > {t("Map")}</button> : null}




                    </ListItem>
                  </>
                ) : (
                  ""
                )
              ) : (
                // data[v] != null && typeof data[v] === "object" ?
                // Object.keys(dat)
                ""
              )
            ) : (
              ""
            );
          })
        : ""}

      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit
        style={{ paddingLeft: "15px" }}
      >
        <List key={Math.random() * 10} component="div" style={{ padding: 0 }}>
          {data &&
            Object.keys(data).map((k, i) => {
              // if (!first) setFirst(true);
              // //  console.log("data k", k);
              return data[k] != null && typeof data[k] === "object" ? (
                <>
                  <TreeCustom
                    increasenumber={increasenumber}
                    decreasenumber={decreasenumber}
                    handleArr={handleArr}
                    key={Math.random()}
                    entry={data}
                    samplejson={samplejson}
                    stateForCustomServiceJson={stateForCustomServiceJson}
                    setStateForCustomServiceJson={setStateForCustomServiceJson}
                    data={data[k]}
                    parentName={Array.isArray(data) ? "" : k}
                    // totalparent={totalparent + k + "."}
                    totalparent={totalparent + `${k}` + "."}
                    length={Object.keys(data[k]).length}
                    isfirst={false}
                    filter={filter}
                    ischeckbox={ischeckbox}
                    arr={arr}
                    saveInJson={saveInJson}
                    searching={searching}
                    searchWord={searchWord}

                    parentMapping={parentMapping}
                    childMapping={childMapping}
                    setparentMapping={setparentMapping}
                    setchildMapping={setchildMapping}
                    setSelectedMappedValue={setSelectedMappedValue}
                    selectedMappedValue={selectedMappedValue}

                    parentChildCustom={parentChildCustom}
                    setParentChildCustom={setParentChildCustom}

                    showMapButtonState={showMapButtonState}
                    setShowMapButtonState={setShowMapButtonState}
                    customServiceIds={customServiceIds}
                    setcustomServiceIds={setcustomServiceIds}

                  />
                </>
              ) : (
                <>
                  {/* outer most div */}
                  <ListItem
                    key={Math.random() * 10}
                    button
                    className={classes.nested}
                  >
                    {!Array.isArray(data) ? (
                      // <ListItemText
                      //   key={Math.random() * 10}
                      //   classes={{ root: classes.listItemText }}
                      // >
                      <ListItem
                        className="hoverclass"
                        style={{
                          flex: "0 1 auto",
                          marginRight: "7px",
                          listStyleType: "none",
                          margin: 0,
                          paddingTop: 0,
                          paddingBottom: 0,
                          paddingLeft:"1px",
                          paddingRight:"1px"
                          // border: "2px solid red",
                        }}
                      >
                        {/* {k == "label" && */}
                        {data[k].toLowerCase().indexOf(filter.toLowerCase()) >
                          -1 ? (
                          <>
                            {/* {//  console.log("k", entry)} */}

                            {searching && k.includes(searchWord) && k!=="mappedinput" ?
                            <>
                            <ItemCustom
                              increasenumber={increasenumber}
                              decreasenumber={decreasenumber}
                              handleArr={handleArr}
                              entry={entry}
                              random={k}
                              samplejson={samplejson}
                              stateForCustomServiceJson={stateForCustomServiceJson}
                              setStateForCustomServiceJson={setStateForCustomServiceJson}
                              dt={data}
                              parentname={parentName}
                              totalparent={totalparent}
                              ischeckbox={ischeckbox}
                              boxes={boxes}
                              arr={arr}
                              saveInJson={saveInJson}
                              searching={searching}
                              searchWord={searchWord}

                              parentMapping={parentMapping}
                              childMapping={childMapping}
                              setparentMapping={setparentMapping}
                              setchildMapping={setchildMapping}
                              setSelectedMappedValue={setSelectedMappedValue}
                              selectedMappedValue={selectedMappedValue}

                              parentChildCustom={parentChildCustom}
                              setParentChildCustom={setParentChildCustom}

                              showMapButtonState={showMapButtonState}
                              setShowMapButtonState={setShowMapButtonState}
                              customServiceIds={customServiceIds}
                              setcustomServiceIds={setcustomServiceIds}

                            ></ItemCustom>
                            </> : null}

                            {!searching && k!=="mappedinput" ?
                            <>
                            <ItemCustom
                              increasenumber={increasenumber}
                              decreasenumber={decreasenumber}
                              handleArr={handleArr}
                              entry={entry}
                              random={k}
                              samplejson={samplejson}
                              stateForCustomServiceJson={stateForCustomServiceJson}
                              setStateForCustomServiceJson={setStateForCustomServiceJson}
                              dt={data}
                              parentname={parentName}
                              totalparent={totalparent}
                              ischeckbox={ischeckbox}
                              boxes={boxes}
                              arr={arr}
                              saveInJson={saveInJson}
                              searching={searching}
                              searchWord={searchWord}

                              parentMapping={parentMapping}
                              childMapping={childMapping}
                              setparentMapping={setparentMapping}
                              setchildMapping={setchildMapping}
                              setSelectedMappedValue={setSelectedMappedValue}
                              selectedMappedValue={selectedMappedValue}

                              parentChildCustom={parentChildCustom}
                              setParentChildCustom={setParentChildCustom}

                              showMapButtonState={showMapButtonState}
                              setShowMapButtonState={setShowMapButtonState}
                              customServiceIds={customServiceIds}
                              setcustomServiceIds={setcustomServiceIds}

                            ></ItemCustom>
                            </> : null}



                          </>



                        ) : (
                          <div
                            className="noneid"
                            style={{ visibility: "hiding", maxHeight: "0px" }}
                          ></div>
                        )}
                      </ListItem>
                    ) : (
                      // </ListItemText>
                      <div
                        className="noneid"
                        style={{ visibility: "hiding", maxHeight: "0px" }}
                      ></div>
                    )}
                  </ListItem>
                </>
              );
            })}
        </List>
      </Collapse>
    </div>
  );
}
